import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import MobileContactUs from './mobileContactUs';
import DesktopContactUs from './desktopContactUs';
import styles from './_contactUs.module.scss';

const contactUsData = {
  title: 'Contact us with any questions',
  number: 9136099947,
  email: 'hello@savvyapp.in',
};

class ContactUs extends Component {
  render() {
    return (
      <>
        <div className={cx(styles['contact-us-page-container'])}>
          <div className={styles['mobile']}>
            <MobileContactUs contactUsData={contactUsData} />
          </div>
          <div className={styles['desktop']}>
            <DesktopContactUs contactUsData={contactUsData} />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ContactUs);
